import { Drawer as ChakraDrawer, Portal } from '@chakra-ui/react';
import { forwardRef } from 'react';

import CloseButton from 'ui/CloseButton';

type DrawerContentProps = ChakraDrawer.ContentProps & {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
  offset?: ChakraDrawer.ContentProps['padding'];
};

const DrawerContent = forwardRef<HTMLDivElement, DrawerContentProps>(
  ({ children, portalled = true, portalRef, offset, ...rest }, ref) => (
    <Portal disabled={!portalled} container={portalRef}>
      <ChakraDrawer.Positioner padding={offset}>
        <ChakraDrawer.Content ref={ref} {...rest} asChild={false}>
          <ChakraDrawer.CloseTrigger
            position="absolute"
            top={2}
            insetEnd={2}
            asChild
          >
            <CloseButton color="gray.800" />
          </ChakraDrawer.CloseTrigger>
          {children}
        </ChakraDrawer.Content>
      </ChakraDrawer.Positioner>
    </Portal>
  )
);

const DrawerRoot: React.FC<ChakraDrawer.RootProps> = ({
  children,
  ...rest
}) => (
  <ChakraDrawer.Root {...rest}>
    <ChakraDrawer.Backdrop />
    {children}
  </ChakraDrawer.Root>
);

const Drawer = {
  Content: DrawerContent,
  Trigger: ChakraDrawer.Trigger,
  Root: DrawerRoot,
  Footer: ChakraDrawer.Footer,
  Header: ChakraDrawer.Header,
  Body: ChakraDrawer.Body,
  Title: ChakraDrawer.Title,
  ActionTrigger: ChakraDrawer.ActionTrigger,
};

export default Drawer;
